// components/FloatingWidget/FloaterIcons.jsx
// npm i react-icons
import {
  FaWhatsapp, FaLine, FaFacebookMessenger, FaTelegramPlane, FaWeixin,
  FaPhoneAlt, FaEnvelope, FaLink, FaCommentDots, FaTimes,
  FaFacebook, FaInstagram, FaTiktok, FaYoutube,
} from 'react-icons/fa'

export const CHANNEL_ICONS = {
  whatsapp: FaWhatsapp,
  line: FaLine,
  messenger: FaFacebookMessenger,
  telegram: FaTelegramPlane,
  wechat: FaWeixin,
  phone: FaPhoneAlt,
  email: FaEnvelope,
  facebook: FaFacebook,
  instagram: FaInstagram,
  tiktok: FaTiktok,
  youtube: FaYoutube,
  custom: FaLink,
  chat: FaCommentDots,
  close: FaTimes,
}

// Choices for the menu (toggle) button icon
export const MAIN_ICON_CHOICES = ['chat', 'whatsapp', 'line', 'phone', 'email', 'messenger', 'telegram']

export function FloaterIcon({ type, url, color, className = 'fw-icon' }) {
  if (url) return <img src={url} alt="" className={className} style={{ objectFit: 'contain' }} />
  const Icon = CHANNEL_ICONS[type] ?? FaCommentDots
  return <Icon className={className} color={color} aria-hidden="true" focusable="false" />
}